import { combineReducers } from 'redux'
import { walletReducer } from './wallet'
import { menuReducer } from './menu'
import { authReducer } from './auth'

export const reducer = combineReducers({
  walletReducer,
  menuReducer,
  authReducer
})


// WEBPACK FOOTER //
// ./src/store/reducers/index.js